const getStaticData = name => {
  const result = window.staticData.find(x => x.name === name)
  return result.options
}

export default getStaticData
